import { render, staticRenderFns } from "./CAlert.vue?vue&type=template&id=922492ce&scoped=true"
import script from "./CAlert.vue?vue&type=script&lang=js"
export * from "./CAlert.vue?vue&type=script&lang=js"
import style0 from "./CAlert.vue?vue&type=style&index=0&id=922492ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922492ce",
  null
  
)

export default component.exports